PJQ.models.invoicing.Invoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    getSummary: function(callback){
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/summary',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            if(typeof callback === 'function'){
                callback(response);
            }
        }, this)).fail(_.bind(function (response) {

        }, this));
    },
    beforeSave: function () {
        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.getChangedModels()
        });
    },
    fetchPossibleLineItems: function (callback) {
        let fnCallback = _.bind(function(){
            if(typeof callback === 'function'){
                callback(this.possibleLineItems);
            }
        }, this)
        if(this.possibleLineItems != null){
            fnCallback();
        }
        else{
            new PJQ.ajax.Request({
                endpoint: this.endpoint() + '/lineitemoptions',
                isAPIv2: true
            }).get().done(_.bind(function (response) {
                let coll;
                if(this instanceof PJQ.models.invoicing.PayableInvoice){
                    coll = PJQ.collections.invoicing.PayableInvoiceLineItems;
                }
                else{
                    coll = PJQ.collections.invoicing.ReceivableInvoiceLineItems;
                }
                this.possibleLineItems  = new coll(response);
                fnCallback();
            }, this)).fail(_.bind(function () {
                fnCallback();
            }, this));
        }
    },
    getSubTotal: function () {
        return this.get('amount');
    },
    getRetainage: function () {
        return this.get('workRetainage') + this.get('materialRetainage');
    },
    getRetainageReleased: function () {
        return this.get('workRetainageReleased') + this.get('materialRetainageReleased');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount');
    }
});

PJQ.models.invoicing.InvoiceLineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    parse: function(model) {
        if(!model)
            return model;

        if (model && model.group) {
            this.group = new PJQ.models.groups.Group(model.group);
        }
        else
            this.group = null;

        return model;
    },
    getWorkRetainageRemaining: function(invoice){
        let wRetain = (this.get('workRetainageTotal') - this.get('workRetainageReleasedTotal'));
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            wRetain += this.get('workRetainage') - this.get('workRetainageReleased');
        }
        return wRetain;
    },
    getMaterialRetainageRemaining: function(invoice){
        let mRetain = (this.get('materialRetainageTotal') - this.get('materialRetainageReleasedTotal'));
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            mRetain += this.get('materialRetainage') - this.get('materialRetainageReleased');
        }
        return mRetain;
    },
    getWorkRetainageTotal: function(invoice){
        let wRetain = (this.get('workRetainageTotal') - this.get('workRetainageReleasedTotal'));
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            wRetain += this.get('workRetainage');
        }
        return wRetain;
    },
    getMaterialRetainageTotal: function(invoice){
        let mRetain = (this.get('materialRetainageTotal') - this.get('materialRetainageReleasedTotal'));
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            mRetain += this.get('materialRetainage');
        }
        return mRetain;
    },
    getProgressAmountTotal: function(invoice){
        let progressAmount = this.get('progressAmountTotal');
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            progressAmount += this.get('progressAmount');
        }
        return progressAmount
    },
    getTotalCompleteAndStored: function(invoice){
        return this.getProgressAmountTotal(invoice) + this.getMaterialsStored(invoice);
    },
    getBalanceToFinish: function(invoice){
        return this.get('committedAmount') - this.getTotalCompleteAndStored(invoice);
    },
    getMaterialsStored: function(invoice){
        let matStored = this.get('materialsStoredTotal')
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            matStored += this.get('materialsNew');
        }
        return matStored;
    },
    getTaxAmount: function () {
        if(this.get('progressPercent') === 100){
            let taxTotal = this.get('progressTaxAmountTotal'),
                committedTax = this.get('committedTaxAmount');
            return committedTax - taxTotal;
        }

        let taxRate = this.get('taxRate'),
            taxable = this.get('progressAmount') + this.get('materialsNew');
        return Math.round(taxable * (taxRate / 10000));
    },
    getUnRoundedTaxAmount: function () {
        let taxRate = this.get('taxRate'),
            taxable = this.get('progressAmount') + this.get('materialsNew') - this.getRetainage() + this.getRetainageReleased();
        return taxable * (taxRate / 10000);
    },
    getSubTotal: function () {
        return this.get('progressAmount') + this.get('materialsNew');
    },
    getRetainage: function () {
        return this.get('workRetainage') + this.get('materialRetainage');
    },
    getRetainageReleased: function () {
        return this.get('workRetainageReleased') + this.get('materialRetainageReleased');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount') - this.getRetainage() + this.getRetainageReleased();
    },
});

PJQ.collections.invoicing.Invoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.Invoice
});

PJQ.collections.invoicing.InvoiceLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.InvoiceLineItem
});